
import Hero from '@/components/about/Hero'
import IBelieve from '@/components/about/IBelieve'
import YouTriedItAll from '@/components/about/YouTriedItAll'
import ConsiderThis from '@/components/about/ConsiderThis'
import YouFoundHer from '@/components/about/YouFoundHer'
import MoreAboutFiona from '@/components/about/MoreAboutFiona'
import GlimpseIntoHowIGotHere from '@/components/about/GlimpseIntoHowIGotHere'
import DontGiveUpNow from '@/components/about/DontGiveUpNow'
import ChooseYourPath from '@/components/shared/ChooseYourPath'
import WhatOthersAreSaying from '@/components/shared/WhatOthersAreSaying'
import HaveQuestionsContainer from '@/components/about/HaveQuestionsContainer'
export default {
  name: 'AboutPage',
  components: {
    HaveQuestionsContainer,
    WhatOthersAreSaying,
    ChooseYourPath,
    DontGiveUpNow,
    GlimpseIntoHowIGotHere,
    MoreAboutFiona,
    YouFoundHer,
    ConsiderThis,
    YouTriedItAll,
    IBelieve,
    Hero,
  },
  layout: 'noheader',
  data() {
    return {
      title: `About Fiona | ${this.$config.siteTitle}`,
      description:
        'Fiona Lazar is the creator, nutritionist, and chef behind Plants So Good, the ultimate resource for those wanting to master a plant-based diet.',
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/about-us/og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/about-us/og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1200',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '630',
        },
      ],
    }
  },
  computed: {
    pageUrl() {
      return `${this.$config.baseURL}${this.$route.fullPath}`
    },
  },
}
